// import '../../GlobalComponents/ReactSelect.css'

import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'

import { custTagsClearSelectedTagUIDsChanged } from '../../features/customerTags/customerTagsSlice'
import { getAPIURL } from '../../GlobalComponents/URLs'
import useDebounce from './use-debounce'

// import { custTagsClearSelectedTagUIDsChanged } from '../Actions/customerTagsActions';
export default function TagUIDSelect(props) {
    const dispatch = useDispatch()
    const [options, setOptions] = useState([]) // API search results
    const [selectedValue, setSelectedValue] = useState('') // Selected option  MAY NOT BE NECESSARY!!!!!!!
    const [inputValue, setInputValue] = useState('') // Keyed search
    const debouncedInputValue = useDebounce(inputValue, 400) // Fire api only when user stops typing
    const clearSelectedTagUIDs = useSelector(
        (state) => state.customerTagsReducer.clearSelectedTagUIDs
    )

    if (clearSelectedTagUIDs) {
        setSelectedValue('')
        dispatch(custTagsClearSelectedTagUIDsChanged(false))
        handleOnChange()
    }

    // API Calls----------------------------------------------------------------
    useEffect(() => {
        const controller = new AbortController()
        // Pass params to include "starts with" keyed inputValue OR equal to selectedValue
        var apiParams = {
            selectedValue: selectedValue.toString(),
            inputValue:
                debouncedInputValue.length > 0 ? '%' + debouncedInputValue.trimEnd() + '%' : '',
            maxReturnedBytes: 500000,
        }
        if (selectedValue.toString().length > 0 || debouncedInputValue.length > 0) {
            let tree_url = getAPIURL() + 'lcm/taguids'
            fetch(tree_url, {
                credentials: 'include',
                method: 'post',
                body: JSON.stringify(apiParams),
                signal: controller.signal,
                headers: { 'Content-type': 'application/json' },
            })
                .then((resp) => {
                    if (resp.ok) {
                        return resp.json()
                    } else throw new Error('bad request ' + resp.statusText)
                })
                .then((json) => {
                    if (json.length > 0) {
                        setOptions(json)
                    } else {
                        setOptions([])
                    }
                })
                .catch((e) => {
                    console.error('Error:', e)
                })
        } else {
            setOptions([])
        }

        return () => {
            controller.abort()
        }
    }, [debouncedInputValue, selectedValue])

    function handleOnChange(event) {
        // Parse out TagUID from event.TagValue (single value for now)
        var Tags = []
        var OrderTagIds = []
        if (event != null) {
            let TagUID = parseInt(event.value.split('|')[0])
            Tags.push(TagUID)

            let orderTagId = parseInt(event.value.split('|')[2])
            OrderTagIds.push(orderTagId)
        }
        event != null ? setSelectedValue(event) : setSelectedValue('')
        props.onChange(Tags, OrderTagIds)
    }

    function onInputChange(query, action) {
        if (query !== inputValue) setInputValue(query)
        return query
    }

    function convertOptions(fpOptions) {
        // Since react-select searches both the label and value, we add the modified string to the value with a pipe
        // and later parse it out in the onChange events.
        var ddlOptions = []

        for (var i in fpOptions) {
            ddlOptions.push({
                label:
                    fpOptions[i].TagUID.toString() +
                    ' | ' +
                    fpOptions[i].Tag +
                    ' | ' +
                    fpOptions[i].SerialNumber +
                    ' | ' +
                    fpOptions[i].AssetType.substring(0, 15),
                value:
                    fpOptions[i].TagUID.toString() +
                    '|' +
                    fpOptions[i].Tag.replace('-', '').replace(' ', '') +
                    '|' +
                    fpOptions[i].OrderTagId.toString(),
            })
        }
        return ddlOptions
    }

    // Render-------------------------------------------------------------------
    // Note:  Use Chrome's inspect on the drop down options list by hovering over the list and clicking F8

    return (
        <>
            <Select
                isClearable
                isSearchable
                value={selectedValue}
                styles={{
                    menu: (provided) => ({ ...provided, zIndex: 100003 }),
                    input: (base) => ({
                        ...base,
                        minWidth: 200,
                    }),
                }}
                noResultsText={() => null}
                className="react-select-container"
                classNamePrefix="react-select"
                options={convertOptions(options)}
                optionHeight={45}
                onChange={handleOnChange}
                matchPos={'any'}
                inputValue={inputValue}
                onInputChange={onInputChange}
                placeholder={'All Tags or Search by ID, Tag# or S/N'}
            />
        </>
    )
}
